webpackJsonp([7,153],{

/***/ 2471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__ = __webpack_require__(1274);
/* harmony default export */ __webpack_exports__["a"] = ({methods:{goToSection:function goToSection(path){var needsPatientId=!this.$store.getters['session/userIsPatient']&&this.$route.query.patientId;var route={path:''+__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["d" /* BASE_PATH */]+(path!==__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["P" /* MENU_PATH */]?'/'+path:''),query:{}};if(needsPatientId)route.query.patientId=this.$route.query.patientId;if(this.$route.query.petId)route.query.petId=this.$route.query.petId;this.$router.push(route).catch(function(){});}},data:function data(){return{historyReadOnly:!!sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */])};},watch:{items:function items(value){this.$emit('anyItemSelected',value&&value.length>0);},zeroItems:function zeroItems(value){this.$emit('anyItemSelected',value);}}});

/***/ }),

/***/ 2477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddButton_vue__ = __webpack_require__(2556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b0fcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__ = __webpack_require__(2604);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2602)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b0fcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/buttons/AddButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38b0fcd7", Component.options)
  } else {
    hotAPI.reload("data-v-38b0fcd7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-button',
  props: {
    buttonText: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('add-btn');
      }
    },
    showTextOnMobile: Boolean
  },
  computed: {
    btnText: function btnText() {
      return this.$uiHelpers.isMobile && !this.showTextOnMobile ? '' : this.buttonText;
    }
  },
  data: function data() {
    return {
      hover: false
    };
  }
});

/***/ }),

/***/ 2602:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1c10b383", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38b0fcd7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38b0fcd7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2603:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("icon-button", {
    attrs: {
      icon: "/static-appopensalud/img/icons/morillas-svg-icons/primary/add.svg",
      text: _vm.btnText
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b0fcd7", esExports)
  }
}

/***/ }),

/***/ 2991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_wrapper_mixin__ = __webpack_require__(531);
//
//
//
//
//
//
//
//
//
//
//
//




var messages = {
    es: {
        'time-picker.select-hour': 'Seleccione una hora',
        'time-picker.decrement': 'Disminuir',
        'time-picker.increment': 'Aumentar',
        'time-picker.no-time-selected': 'Hora no seleccionada',
        'time-picker.current-time': 'hora actual',
        'time-picker.reset-btn': 'Resetear'
    },
    en: {
        'time-picker.select-hour': 'Select a time',
        'time-picker.decrement': 'Decrease',
        'time-picker.increment': 'Increase',
        'time-picker.no-time-selected': 'Hour not selected',
        'time-picker.current-time': 'Current time',
        'time-picker.reset-btn': 'Reset'
    },
    pt: {
        'time-picker.select-hour': 'Selecione um horário',
        'time-picker.decrement': 'Decremento',
        'time-picker.increment': 'Incremento',
        'time-picker.no-time-selected': 'Hora não selecionada',
        'time-picker.current-time': 'Hora atual',
        'time-picker.reset-btn': 'Redefinir'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_1__mixins_wrapper_mixin__["a" /* default */])(String)],
    i18n: {
        messages: messages
    },
    components: {
        BFormTimepicker: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["B" /* BFormTimepicker */],
        BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */]
    },
    props: {
        showSeconds: Boolean,
        resetButtton: Boolean,
        noMarginBottom: Boolean,
        label: {
            type: String,
            required: false,
            default: ''
        },
        description: {
            type: String,
            required: false,
            default: ''
        },
        resetButton: {
            type: Boolean,
            default: true
        },
        nowButton: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: function _default() {
                return this.$t('time-picker.selectHour');
            }
        }
    },
    data: function data() {
        return {};
    },
    mounted: function mounted() {},
    created: function created() {},

    methods: {}
});

/***/ }),

/***/ 2992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//



var messages = {
  es: {
    'binary-radio-group': {
      'error-msg': 'Seleccione una opción'
    }
  },
  en: {
    'binary-radio-group': {
      'error-msg': 'Select an option'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'base-radio-group': function baseRadioGroup() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 1273));
    },
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */]
  },
  i18n: {
    messages: messages
  },
  props: {
    value: [String, Object, Boolean],
    options: {
      type: Array,
      required: false,
      default: function _default() {
        return [{ value: true, text: this.$t('yes') }, { value: false, text: this.$t('no') }];
      }
    },
    state: {
      type: [Boolean, Object],
      required: false,
      default: null
    },
    errorMsg: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('binary-radio-group.error-msg');
      }
    },
    noMarginTop: Boolean
  },
  data: function data() {
    return {
      localValue: null
    };
  },
  created: function created() {
    var _this = this;

    this.localValue = this.value;
    this.$watch('localValue', function (value) {
      _this.$emit('input', value);
    });
  }
});

/***/ }),

/***/ 3167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Repository__ = __webpack_require__(543);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__Repository__["a" /* default */]('medicationReminder'));

/***/ }),

/***/ 3168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTimepicker_vue__ = __webpack_require__(2991);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db34ee2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTimepicker_vue__ = __webpack_require__(3171);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3169)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db34ee2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTimepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db34ee2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTimepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BaseTimepicker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db34ee2c", Component.options)
  } else {
    hotAPI.reload("data-v-db34ee2c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3169:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3170);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0d3d7551", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db34ee2c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseTimepicker.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db34ee2c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BaseTimepicker.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3170:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-db34ee2c]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-db34ee2c],.slide-down-leave-active[data-v-db34ee2c]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-db34ee2c],.slide-down-leave-to[data-v-db34ee2c]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-db34ee2c],.slide-fade-left-leave-active[data-v-db34ee2c]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-db34ee2c],.slide-fade-left-leave-to[data-v-db34ee2c]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-db34ee2c]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-db34ee2c],.fade-leave-to[data-v-db34ee2c]{opacity:0\n}\n", ""]);

// exports


/***/ }),

/***/ 3171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          class: { "no-margin-bottom": _vm.noMarginBottom },
          staticStyle: { "text-align": "initial !important" },
          attrs: {
            label: _vm.label,
            "label-for": _vm.id,
            description: _vm.description
          }
        },
        [
          _c(
            "div",
            [
              _c("b-form-timepicker", {
                attrs: {
                  placeholder: _vm.placeholder,
                  "label-close-button": _vm.$t("close"),
                  "label-decrement": _vm.$t("time-picker.decrement"),
                  "label-increment": _vm.$t("time-picker.increment"),
                  "reset-button": _vm.resetButton,
                  "label-hours": _vm.$t("hours"),
                  "label-minutes": _vm.$t("minutes"),
                  "label-seconds": _vm.$t("seconds"),
                  "label-no-time-selected": _vm.$t(
                    "time-picker.no-time-selected"
                  ),
                  "label-now-button": _vm.$t("time-picker.current-time"),
                  dropup: "",
                  "label-reset-button": _vm.$t("time-picker.reset-btn"),
                  locale: _vm.$i18nHelpers.getNormalizedLocale(),
                  "show-seconds": _vm.showSeconds,
                  "close-button-variant": "secondary",
                  "now-button": _vm.nowButton
                },
                on: {
                  input: function($event) {
                    return _vm.$emit("input", $event)
                  }
                },
                model: {
                  value: _vm.localValue,
                  callback: function($$v) {
                    _vm.localValue = $$v
                  },
                  expression: "localValue"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db34ee2c", esExports)
  }
}

/***/ }),

/***/ 3172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BinaryRadioGroup_vue__ = __webpack_require__(2992);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d75047a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BinaryRadioGroup_vue__ = __webpack_require__(3175);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3173)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d75047a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BinaryRadioGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d75047a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BinaryRadioGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/forms/BinaryRadioGroup.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d75047a", Component.options)
  } else {
    hotAPI.reload("data-v-7d75047a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3173:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3174);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("03744d08", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d75047a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BinaryRadioGroup.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7d75047a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BinaryRadioGroup.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3174:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-7d75047a]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-7d75047a],.slide-down-leave-active[data-v-7d75047a]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-7d75047a],.slide-down-leave-to[data-v-7d75047a]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-7d75047a],.slide-fade-left-leave-active[data-v-7d75047a]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-7d75047a],.slide-fade-left-leave-to[data-v-7d75047a]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-7d75047a]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-7d75047a],.fade-leave-to[data-v-7d75047a]{opacity:0\n}\n.no-margin-top[data-v-7d75047a]{margin-top:0\n}\n", ""]);

// exports


/***/ }),

/***/ 3175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("base-radio-group", {
        class: { "no-margin-top": _vm.noMarginTop },
        attrs: { options: _vm.options },
        model: {
          value: _vm.localValue,
          callback: function($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue"
        }
      }),
      _vm._v(" "),
      _c("b-form-invalid-feedback", { attrs: { state: _vm.state } }, [
        _vm._v("\n    " + _vm._s(_vm.errorMsg) + "\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d75047a", esExports)
  }
}

/***/ }),

/***/ 3516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__repositories_MedicationReminderRepository__ = __webpack_require__(3167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_views_clinicHistory_medicationReminder_MedicationReminderForm__ = __webpack_require__(4082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_views_clinicHistory_medicationReminder_MedicationReminderBlock__ = __webpack_require__(4086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_BackButton__ = __webpack_require__(1282);
//
//
//
//
//
//
//
//
//
//
//
//
//







var MEDICATION_REMINDER_ROUTE_NAME = 'medicationReminder';
var NEW_MEDICATION_REMINDER_ROUTE_NAME = 'newMedicationReminder';
var EDIT_MEDICATION_REMINDER_ROUTE_NAME = 'editMedicationReminder';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        AddButton: __WEBPACK_IMPORTED_MODULE_3__components_base_buttons_AddButton__["a" /* default */],
        BackButton: __WEBPACK_IMPORTED_MODULE_4__components_base_buttons_BackButton__["a" /* default */],
        MedicationReminderForm: __WEBPACK_IMPORTED_MODULE_1__components_views_clinicHistory_medicationReminder_MedicationReminderForm__["a" /* default */],
        MedicationReminderBlock: __WEBPACK_IMPORTED_MODULE_2__components_views_clinicHistory_medicationReminder_MedicationReminderBlock__["a" /* default */]
    },
    data: function data() {
        return {
            showCreateForm: false,
            reminders: [],
            formData: null
        };
    },
    created: function created() {
        var _this = this;

        window.scrollTo(0, 0);
        if (this.medicationCode) {
            this.showCreateForm = true;
        } else {
            this.getMedicationReminders().then(function (response) {
                if (_this.$router.currentRoute.name === NEW_MEDICATION_REMINDER_ROUTE_NAME) {
                    _this.$router.push({ name: NEW_MEDICATION_REMINDER_ROUTE_NAME });
                    _this.showCreateForm = true;
                } else if (_this.$router.currentRoute.name === EDIT_MEDICATION_REMINDER_ROUTE_NAME) {
                    _this.loadFormData(_this.$route.params.id);
                }
            });
        }
    },

    methods: {
        onAddReminder: function onAddReminder() {
            this.formData = null;
            this.$router.push({ name: NEW_MEDICATION_REMINDER_ROUTE_NAME });
        },
        getMedicationReminders: function getMedicationReminders() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_0__repositories_MedicationReminderRepository__["a" /* default */].getAll().then(function (response) {
                _this2.reminders = response.data || [];
                if (!_this2.reminders.length) {
                    _this2.showCreateForm = true;
                }
            });
        },
        onShowReminderMenu: function onShowReminderMenu() {
            window.scrollTo(0, 0);
            this.getMedicationReminders();
            this.$router.push({ name: MEDICATION_REMINDER_ROUTE_NAME });
            this.showCreateForm = false;
        },
        loadFormData: function loadFormData(id) {
            this.formData = this.reminders.find(function (item) {
                return item.id === id;
            });
            this.showCreateForm = true;
            this.$router.push({ name: EDIT_MEDICATION_REMINDER_ROUTE_NAME, params: { id: id } });
        }
    },
    computed: {
        medicationCode: function medicationCode() {
            return this.$route.params.code;
        }
    }
});

/***/ }),

/***/ 3517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_forms_BaseDatepicker__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseCheckbox__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseTextarea__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_ClinicHistoryRepository__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repositories_MedicationReminderRepository__ = __webpack_require__(3167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_clinicHistory__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_base_buttons_BackButton__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_base_forms_BaseRadioGroup__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_base_forms_BaseTimepicker__ = __webpack_require__(3168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_base_forms_BinaryRadioGroup__ = __webpack_require__(3172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__ = __webpack_require__(3518);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















var REMINDER_DEFAULT_VALUE = { value: 1, startHour: '06:00', endHour: '00:00' };

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseDatepicker: __WEBPACK_IMPORTED_MODULE_1__components_base_forms_BaseDatepicker__["default"],
        BackBtn: __WEBPACK_IMPORTED_MODULE_8__components_base_buttons_BackButton__["a" /* default */],
        BaseRadioGroup: __WEBPACK_IMPORTED_MODULE_9__components_base_forms_BaseRadioGroup__["default"],
        BaseTimepicker: __WEBPACK_IMPORTED_MODULE_10__components_base_forms_BaseTimepicker__["a" /* default */],
        BFormCheckboxGroup: __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__["o" /* BFormCheckboxGroup */],
        BinaryRadioGroup: __WEBPACK_IMPORTED_MODULE_13__components_base_forms_BinaryRadioGroup__["default"],
        BaseTextArea: __WEBPACK_IMPORTED_MODULE_3__components_base_forms_BaseTextarea__["default"],
        BaseCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseCheckbox__["default"]
    },
    data: function data() {
        return {
            notes: null,
            editing: false,
            notifications: {
                email: true,
                whatsapp: true
            },
            tabletsReminder: {
                total: null,
                left: null,
                limit: null,
                enabled: true
            },
            medicine: {
                value: null,
                tablets: null,
                tabletsOptions: [],
                options: [],
                loading: false
            },
            reminderFrequency: {
                options: [{ value: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["d" /* INTERVAL_FREQUENCY_OPTION */], text: this.$t('reminderMedicationForm.frequency.interval') }, { value: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["e" /* SEVERAL_TIMES_DAY_FREQUENCY_OPTION */], text: this.$t('reminderMedicationForm.frequency.severalTimesDay') }, { value: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["f" /* WEEK_DAYS_FREQUENCY_OPTION */], text: this.$t('reminderMedicationForm.frequency.weekDays') }, { value: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["a" /* CYCLIC_FREQUENCY_OPTION */], text: this.$t('reminderMedicationForm.frequency.cyclic') }],
                interval: {
                    value: 6,
                    optionValue: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["c" /* HOURS_INTERVAL_OPTION */],
                    options: [{ name: this.$t('hours'), value: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["c" /* HOURS_INTERVAL_OPTION */] }, { name: this.$t('days'), value: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["b" /* DAYS_INTERVAL_OPTION */] }],
                    endHoursOptions: []
                },
                severalTimesDay: {
                    value: 3
                },
                weekDays: {
                    value: [],
                    options: this.getWeekDaysNamesFormatted()
                },
                cyclic: {
                    tablets: 21,
                    pauses: 7,
                    startDate: null
                },
                value: null
            },
            MENU_PATH: __WEBPACK_IMPORTED_MODULE_7__constants_clinicHistory__["P" /* MENU_PATH */],
            INTERVAL_FREQUENCY_OPTION: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["d" /* INTERVAL_FREQUENCY_OPTION */],
            SEVERAL_TIMES_DAY_FREQUENCY_OPTION: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["e" /* SEVERAL_TIMES_DAY_FREQUENCY_OPTION */],
            WEEK_DAYS_FREQUENCY_OPTION: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["f" /* WEEK_DAYS_FREQUENCY_OPTION */],
            CYCLIC_FREQUENCY_OPTION: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["a" /* CYCLIC_FREQUENCY_OPTION */],
            HOURS_INTERVAL_OPTION: __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["c" /* HOURS_INTERVAL_OPTION */]
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_clinicHistory_mixin__["a" /* default */]],
    props: {
        formData: Object,
        medicationCode: String
    },
    created: function created() {
        var _this = this;

        window.scrollTo(0, 0);
        if (this.formData) this.loadFormData();
        if (this.medicationCode) {
            this.getMedicationByCode(this.medicationCode).then(function (response) {
                _this.tabletsReminder.limit = parseInt(parseInt(_this.tabletsReminder.total) / 4);
            });
        }
    },

    methods: {
        loadFormData: function loadFormData() {
            this.editing = true;
            this.getMedicationByCode(this.formData.medication.id);
            this.reminderFrequency.value = this.formData.reminderType.id;
            this.tabletsReminder = this.formData.tabletsReminder;
            this.notifications = this.formData.notifications;
            this.notes = this.formData.notes;
            if (this.formData.interval) this.loadIntervalData();
            if (this.formData.severalTimesWeek) this.loadSeveralTimesWeekData();
            if (this.formData.severalTimesDay) this.loadSeveralTimesDayData();
            if (this.formData.cyclic) this.loadCylicData();
        },
        loadIntervalData: function loadIntervalData() {
            this.reminderFrequency.interval.value = this.formData.interval.hours || this.formData.interval.days;
            this.reminderFrequency.interval.optionValue = this.formData.interval.hours ? __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["c" /* HOURS_INTERVAL_OPTION */] : __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["b" /* DAYS_INTERVAL_OPTION */];
            this.medicine.tabletsOptions.push({ value: this.formData.interval.tablets, startHour: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["k" /* getLocalHourFromDate */])(this.formData.interval.startDate), endHour: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["k" /* getLocalHourFromDate */])(this.formData.interval.endDate) });
            this.updateIntervalEndHoursOptions(true);
        },
        loadSeveralTimesWeekData: function loadSeveralTimesWeekData() {
            this.reminderFrequency.weekDays.value = this.formData.severalTimesWeek.weekDaysValues;
            this.medicine.tabletsOptions.push({ value: this.formData.severalTimesWeek.tablets, startHour: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["k" /* getLocalHourFromDate */])(this.formData.severalTimesWeek.startDate) });
        },
        loadSeveralTimesDayData: function loadSeveralTimesDayData() {
            this.reminderFrequency.severalTimesDay.value = this.formData.severalTimesDay.length;
            this.medicine.tabletsOptions = this.formData.severalTimesDay.map(function (item) {
                return { value: item.tablets, startHour: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["k" /* getLocalHourFromDate */])(item.startDate) };
            });
        },
        loadCylicData: function loadCylicData() {
            this.formData.cyclic.cycle.startDate = new Date(this.formData.cyclic.cycle.startDate);
            this.reminderFrequency.cyclic = this.formData.cyclic.cycle;
            this.medicine.tabletsOptions.push({ value: this.formData.cyclic.tablets, startHour: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["k" /* getLocalHourFromDate */])(this.formData.cyclic.startDate) });
        },
        onMedicineSelected: function onMedicineSelected() {
            var _this2 = this;

            var tablets = this.medicine.options.find(function (item) {
                return item.id === _this2.medicine.value;
            }).tablets;
            this.tabletsReminder.left = tablets;
            this.tabletsReminder.total = tablets;
            this.tabletsReminder.limit = parseInt(parseInt(tablets) / 4);
        },
        getMedicationByCode: function getMedicationByCode(code) {
            var _this3 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_5__repositories_ClinicHistoryRepository__["a" /* default */])().getMedicinesById(code).then(function (response) {
                var selectedValue = response.data.data;
                _this3.medicine.options = [selectedValue];
                _this3.medicine.value = selectedValue.id;
                _this3.tabletsReminder.left = selectedValue.tablets;
                _this3.tabletsReminder.total = selectedValue.tablets;
            });
        },
        searchMedicine: function searchMedicine(search) {
            var _this4 = this;

            if (search) {
                Object(__WEBPACK_IMPORTED_MODULE_5__repositories_ClinicHistoryRepository__["a" /* default */])().getMedicinesByName(search).then(function (response) {
                    _this4.medicine.options = response.data.data;
                });
            }
        },
        save: function save() {
            if (!this.medicine.value) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.medicine'));
            } else if (!this.reminderFrequency.value) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.frequencyOption'));
            } else if (!this.notifications.email && !this.notifications.whatsapp) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.notifications'));
            } else if (this.tabletsReminder.enabled && (this.tabletsReminder.limit === null || this.tabletsReminder.left === null)) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsReminderFill'));
            } else if (this.tabletsReminder.enabled && parseInt(this.tabletsReminder.limit) >= parseInt(this.tabletsReminder.left)) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsReminder'));
            } else if (this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["d" /* INTERVAL_FREQUENCY_OPTION */]) {
                this.saveInterval();
            } else if (this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["e" /* SEVERAL_TIMES_DAY_FREQUENCY_OPTION */]) {
                this.saveSeveralTimesDay();
            } else if (this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["f" /* WEEK_DAYS_FREQUENCY_OPTION */]) {
                this.saveWeekDays();
            } else if (this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["a" /* CYCLIC_FREQUENCY_OPTION */]) {
                this.saveCyclic();
            }
        },
        saveInterval: function saveInterval() {
            if (this.reminderFrequency.interval.value < 1) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.interval'));
            } else if (this.medicine.tabletsOptions[0].value < 1) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsLessThan1'));
            } else if (!this.medicine.tabletsOptions[0].startHour) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsFromHour'));
            } else if (!this.medicine.tabletsOptions[0].endHour) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsToHour'));
            } else {
                var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getCommomData(), {
                    interval: {
                        hours: this.reminderFrequency.interval.optionValue === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["c" /* HOURS_INTERVAL_OPTION */] ? this.reminderFrequency.interval.value : null,
                        days: this.reminderFrequency.interval.optionValue === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["b" /* DAYS_INTERVAL_OPTION */] ? this.reminderFrequency.interval.value : null,
                        tablets: this.medicine.tabletsOptions[0].value,
                        startDate: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["h" /* getCurrentDateFromHour */])(this.medicine.tabletsOptions[0].startHour),
                        endDate: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["h" /* getCurrentDateFromHour */])(this.medicine.tabletsOptions[0].endHour)
                    }
                });
                this.saveReminderData(data);
            }
        },
        saveSeveralTimesDay: function saveSeveralTimesDay() {
            if (this.reminderFrequency.severalTimesDay.value < 1) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.intakesDay'));
            } else if (this.medicine.tabletsOptions.some(function (item) {
                return item.value < 1;
            })) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsLessThan1'));
            } else if (this.medicine.tabletsOptions.some(function (item) {
                return !item.startHour;
            })) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsFromHour'));
            } else {
                var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getCommomData(), {
                    severalTimesDay: this.medicine.tabletsOptions.map(function (item) {
                        return { tablets: item.value, startDate: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["h" /* getCurrentDateFromHour */])(item.startHour) };
                    })
                });
                this.saveReminderData(data);
            }
        },
        saveWeekDays: function saveWeekDays() {
            if (!this.reminderFrequency.weekDays.value.length) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.weekDays'));
            } else if (this.medicine.tabletsOptions[0].value < 1) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsLessThan1'));
            } else if (!this.medicine.tabletsOptions[0].startHour) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsFromHour'));
            } else {
                var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getCommomData(), {
                    severalTimesWeek: {
                        tablets: this.medicine.tabletsOptions[0].value,
                        startDate: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["h" /* getCurrentDateFromHour */])(this.medicine.tabletsOptions[0].startHour),
                        weekDaysValues: this.reminderFrequency.weekDays.value
                    }
                });
                this.saveReminderData(data);
            }
        },
        saveCyclic: function saveCyclic() {
            if (!this.reminderFrequency.cyclic.tablets) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsLessThan1'));
            } else if (!this.reminderFrequency.cyclic.startDate) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.cylicStartDate'));
            } else if (this.medicine.tabletsOptions[0].value < 1) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsLessThan1'));
            } else if (!this.medicine.tabletsOptions[0].startHour) {
                this.$store.dispatch('showDangerAlert', this.$t('reminderMedicationForm.error.tabletsFromHour'));
            } else {
                var cyclicData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.reminderFrequency.cyclic);
                var startDateSplitted = typeof cyclicData.startDate === 'string' ? cyclicData.startDate.split('-').map(function (item) {
                    return parseInt(item);
                }) : cyclicData.startDate.toISOString().split('T')[0].split('-').map(function (item) {
                    return parseInt(item);
                });
                cyclicData.startDate = new Date(Date.UTC(startDateSplitted[0], startDateSplitted[1] - 1, startDateSplitted[2], 0, 0, 0));
                var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getCommomData(), {
                    cyclic: {
                        tablets: this.medicine.tabletsOptions[0].value,
                        startDate: Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["j" /* getDateFromDateAndHour */])(cyclicData.startDate, this.medicine.tabletsOptions[0].startHour),
                        cycle: cyclicData
                    }
                });
                this.saveReminderData(data);
            }
        },
        getCommomData: function getCommomData() {
            var _this5 = this;

            var medicine = this.medicine.options.find(function (item) {
                return item.id === _this5.medicine.value;
            });
            return {
                medication: { id: medicine.id, name: medicine.name },
                reminderTypeId: this.reminderFrequency.value,
                tabletsReminder: this.tabletsReminder,
                notes: this.notes,
                notifications: this.notifications
            };
        },
        saveReminderData: function saveReminderData(data) {
            var _this6 = this;

            var responseEvent = function responseEvent(response) {
                if (response.data) {
                    _this6.$emit('onShowReminderMenu');
                } else {
                    _this6.$store.dispatch('showDangerAlert', _this6.$t('defaultErrorMessage'));
                }
            };
            if (this.editing) {
                __WEBPACK_IMPORTED_MODULE_6__repositories_MedicationReminderRepository__["a" /* default */].put(this.formData.id, data).then(function (response) {
                    responseEvent(response);
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_6__repositories_MedicationReminderRepository__["a" /* default */].post(data).then(function (response) {
                    responseEvent(response);
                });
            }
        },
        onReminderChange: function onReminderChange() {
            var defaultValue = REMINDER_DEFAULT_VALUE;
            this.medicine.tabletsOptions = [defaultValue];
            if (this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["e" /* SEVERAL_TIMES_DAY_FREQUENCY_OPTION */]) {
                var currentHour = defaultValue.startHour;
                for (var i = 1; i < this.reminderFrequency.severalTimesDay.value; i++) {
                    currentHour = ((parseFloat(currentHour.replace(':', '.')) + 1) % 24).toFixed(2).replace('.', ':');
                    this.medicine.tabletsOptions.push({ value: 1, startHour: currentHour, endHour: '00:00' });
                }
            } else if (this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["d" /* INTERVAL_FREQUENCY_OPTION */]) {
                this.updateIntervalEndHoursOptions();
            }
        },
        getWeekDaysNamesFormatted: function getWeekDaysNamesFormatted() {
            var weekDays = Object(__WEBPACK_IMPORTED_MODULE_11__helpers_date_helpers__["q" /* getWeekDaysNamesWithValue */])(true);
            weekDays.push(weekDays.shift());

            return weekDays;
        },
        updateIntervalEndHoursOptions: function updateIntervalEndHoursOptions(editing) {
            if (!this.hoursIntervalSelected) return;
            var startHour = parseFloat(this.medicine.tabletsOptions[0].startHour.replace(':', '.'));
            var hoursInterval = parseInt(this.reminderFrequency.interval.value);
            var loopsNumber = parseInt(24 / hoursInterval);
            var pivotHour = (startHour + hoursInterval) % 24;
            var result = [];
            for (var i = 0; i < loopsNumber; i++) {
                if (pivotHour !== startHour) result.push({ value: pivotHour.toFixed(2).replace('.', ':') });
                pivotHour = (pivotHour + hoursInterval) % 24;
            }
            this.medicine.tabletsOptions[0].endHour = editing ? this.medicine.tabletsOptions[0].endHour : result[result.length - 1].value;
            this.reminderFrequency.interval.endHoursOptions = result;
        }
    },
    computed: {
        reminderIntervarlHours: function reminderIntervarlHours() {
            return [{ name: '6 ' + this.$t('hours'), value: 6 }, { name: '8 ' + this.$t('hours'), value: 8 }, { name: '12 ' + this.$t('hours'), value: 12 }, { name: '24 ' + this.$t('hours'), value: 24 }, { name: this.$t('other'), value: 0 }];
        },
        reminderIntervalAlternativeSource: function reminderIntervalAlternativeSource() {
            return [{ name: this.$t('hours'), value: 0 }, { name: this.$t('days'), value: 1 }];
        },
        showStartDate: function showStartDate() {
            return this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["a" /* CYCLIC_FREQUENCY_OPTION */];
        },
        showTabletsSection: function showTabletsSection() {
            return this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["e" /* SEVERAL_TIMES_DAY_FREQUENCY_OPTION */] || this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["f" /* WEEK_DAYS_FREQUENCY_OPTION */] || this.reminderFrequency.value === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["a" /* CYCLIC_FREQUENCY_OPTION */];
        },
        hoursIntervalSelected: function hoursIntervalSelected() {
            return this.reminderFrequency.interval.optionValue === __WEBPACK_IMPORTED_MODULE_14__constants_medicationReminder__["c" /* HOURS_INTERVAL_OPTION */];
        }
    }
});

/***/ }),

/***/ 3518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INTERVAL_FREQUENCY_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEVERAL_TIMES_DAY_FREQUENCY_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WEEK_DAYS_FREQUENCY_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CYCLIC_FREQUENCY_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HOURS_INTERVAL_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DAYS_INTERVAL_OPTION; });
// Medication reminder types
var INTERVAL_FREQUENCY_OPTION='678e377becaf026d09867fdf';var SEVERAL_TIMES_DAY_FREQUENCY_OPTION='678e389becaf026d09867fe0';var WEEK_DAYS_FREQUENCY_OPTION='678e38b7ecaf026d09867fe1';var CYCLIC_FREQUENCY_OPTION='678e38d8ecaf026d09867fe2';// Interval time options
var HOURS_INTERVAL_OPTION=0;var DAYS_INTERVAL_OPTION=1;

/***/ }),

/***/ 3519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_medicationReminder__ = __webpack_require__(3518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_BaseDialog_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_MedicationReminderRepository__ = __webpack_require__(3167);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BaseDialog: __WEBPACK_IMPORTED_MODULE_2__components_base_BaseDialog_vue__["default"]
    },
    data: function data() {
        return {
            showDeleteDialog: false
        };
    },

    props: {
        id: String,
        medicationName: String,
        reminderType: Object,
        tabletsLeft: [Number, String],
        tabletsReminderSent: Boolean,
        notes: String,
        interval: Object,
        cyclic: Object,
        severalTimesWeek: Object,
        severalTimesDay: Array
    },
    methods: {
        deleteMedication: function deleteMedication() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_3__repositories_MedicationReminderRepository__["a" /* default */].delete(this.id).then(function (response) {
                if (response.data) {
                    _this.$emit('onDelete');
                } else {
                    _this.$store.dispatch('showDangerAlert', _this.$t('defaultErrorMessage'));
                }
            });
        },
        resetTablets: function resetTablets() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_3__repositories_MedicationReminderRepository__["a" /* default */].put(this.id, { resetTabletsReminder: true }).then(function (response) {
                if (response.data) {
                    _this2.$store.dispatch('showSuccessAlert', _this2.$t('changesPerformedCorrectly'));
                    _this2.$emit('onRefreshMedications');
                } else {
                    _this2.$store.dispatch('showDangerAlert', _this2.$t('defaultErrorMessage'));
                }
            });
        }
    },
    computed: {
        reminderTypeTitle: function reminderTypeTitle() {
            if (this.reminderType.id === __WEBPACK_IMPORTED_MODULE_0__constants_medicationReminder__["d" /* INTERVAL_FREQUENCY_OPTION */]) {
                return this.intervalTitle;
            } else if (this.reminderType.id === __WEBPACK_IMPORTED_MODULE_0__constants_medicationReminder__["e" /* SEVERAL_TIMES_DAY_FREQUENCY_OPTION */]) {
                return this.severalTimesDayTitle;
            } else if (this.reminderType.id === __WEBPACK_IMPORTED_MODULE_0__constants_medicationReminder__["f" /* WEEK_DAYS_FREQUENCY_OPTION */]) {
                return this.severalTimesWeekTitle;
            } else if (this.reminderType.id === __WEBPACK_IMPORTED_MODULE_0__constants_medicationReminder__["a" /* CYCLIC_FREQUENCY_OPTION */]) {
                return this.cyclicTitle;
            }
        },
        intervalTitle: function intervalTitle() {
            return this.$t('medicationReminderEachXTime', { time: this.interval.hours || this.interval.days, interval: this.interval.hours ? this.$t('hours') : this.$t('days') });
        },
        severalTimesDayTitle: function severalTimesDayTitle() {
            return this.severalTimesDay.length + ' ' + this.$t('timesToDay') + ' - ' + this.severalTimesDay.map(function (item) {
                return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__["k" /* getLocalHourFromDate */])(item.startDate);
            }).join(', ');
        },
        severalTimesWeekTitle: function severalTimesWeekTitle() {
            var _this3 = this;

            return Object(__WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__["q" /* getWeekDaysNamesWithValue */])().filter(function (item) {
                return _this3.severalTimesWeek.weekDaysValues.includes(item.value);
            }).map(function (item) {
                return item.name;
            }).join(', ') + ' - ' + Object(__WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__["k" /* getLocalHourFromDate */])(this.severalTimesWeek.startDate);
        },
        cyclicTitle: function cyclicTitle() {
            return this.$t('reminderMedicationForm.frequency.cyclic') + ' (' + this.cyclic.cycle.tablets + ' ' + this.$t('reminderMedicationForm.intakes') + ', ' + this.cyclic.cycle.pauses + ' ' + this.$t('reminderMedicationForm.pauses') + ') - ' + Object(__WEBPACK_IMPORTED_MODULE_1__helpers_date_helpers__["k" /* getLocalHourFromDate */])(this.cyclic.startDate);
        }
    }
});

/***/ }),

/***/ 4080:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4081);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5a670aa7", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-67cd7020\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MedicationReminderView.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-67cd7020\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MedicationReminderView.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4081:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-67cd7020]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-67cd7020],.slide-down-leave-active[data-v-67cd7020]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-67cd7020],.slide-down-leave-to[data-v-67cd7020]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-67cd7020],.slide-fade-left-leave-active[data-v-67cd7020]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-67cd7020],.slide-fade-left-leave-to[data-v-67cd7020]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-67cd7020]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-67cd7020],.fade-leave-to[data-v-67cd7020]{opacity:0\n}\n.row-gap[data-v-67cd7020]{gap:2rem\n}\n", ""]);

// exports


/***/ }),

/***/ 4082:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicationReminderForm_vue__ = __webpack_require__(3517);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde41ae2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicationReminderForm_vue__ = __webpack_require__(4085);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4083)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bde41ae2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicationReminderForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde41ae2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicationReminderForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/medicationReminder/MedicationReminderForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bde41ae2", Component.options)
  } else {
    hotAPI.reload("data-v-bde41ae2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4083:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4084);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("02bb6632", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bde41ae2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MedicationReminderForm.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-bde41ae2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MedicationReminderForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4084:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-bde41ae2]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-bde41ae2],.slide-down-leave-active[data-v-bde41ae2]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-bde41ae2],.slide-down-leave-to[data-v-bde41ae2]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-bde41ae2],.slide-fade-left-leave-active[data-v-bde41ae2]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-bde41ae2],.slide-fade-left-leave-to[data-v-bde41ae2]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-bde41ae2]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-bde41ae2],.fade-leave-to[data-v-bde41ae2]{opacity:0\n}\n.row h5[data-v-bde41ae2]{text-align:center\n}\n.text-center[data-v-bde41ae2]{text-align:center\n}\n.row-gap[data-v-bde41ae2]{gap:1rem\n}\n.vertical-align[data-v-bde41ae2]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.inline-block[data-v-bde41ae2]{display:inline-block\n}\n.block-center[data-v-bde41ae2]{display:block;text-align:center\n}\n[data-v-bde41ae2] .custom-checkbox{margin-top:0\n}\n", ""]);

// exports


/***/ }),

/***/ 4085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-card",
        { attrs: { overflowVisible: "" } },
        [
          _c("h3", {
            staticClass: "text-center mb-4",
            domProps: { innerHTML: _vm._s(_vm.$t("medicationReminder")) }
          }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-center mb-4" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", xl: "6" } },
                [
                  _c("base-select", {
                    attrs: {
                      searchable: "",
                      loading: _vm.medicine.loading,
                      options: _vm.medicine.options,
                      label: "name",
                      valueProp: "id",
                      placeholder: _vm.$t("enterMedicineName")
                    },
                    on: {
                      search: function($event) {
                        return _vm.searchMedicine($event)
                      },
                      "option:selected": _vm.onMedicineSelected
                    },
                    model: {
                      value: _vm.medicine.value,
                      callback: function($$v) {
                        _vm.$set(_vm.medicine, "value", $$v)
                      },
                      expression: "medicine.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.medicine.value
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("h5", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("reminderMedicationForm.frequencyTitle")
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("base-radio-group", {
                            attrs: { options: _vm.reminderFrequency.options },
                            on: { input: _vm.onReminderChange },
                            model: {
                              value: _vm.reminderFrequency.value,
                              callback: function($$v) {
                                _vm.$set(_vm.reminderFrequency, "value", $$v)
                              },
                              expression: "reminderFrequency.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.reminderFrequency.value === _vm.INTERVAL_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: {
                                  type: "number",
                                  min: 1,
                                  max: _vm.hoursIntervalSelected ? 23 : 90
                                },
                                on: {
                                  input: _vm.updateIntervalEndHoursOptions
                                },
                                model: {
                                  value: _vm.reminderFrequency.interval.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.interval,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "reminderFrequency.interval.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-4",
                              attrs: { cols: "12", md: "3", xl: "2" }
                            },
                            [
                              _c("base-select", {
                                attrs: {
                                  loading: false,
                                  options:
                                    _vm.reminderFrequency.interval.options,
                                  label: "name",
                                  valueProp: "value",
                                  placeholder: _vm.$t(
                                    "reminderMedicationForm.option"
                                  )
                                },
                                model: {
                                  value:
                                    _vm.reminderFrequency.interval.optionValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.interval,
                                      "optionValue",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reminderFrequency.interval.optionValue"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reminderFrequency.value ===
                  _vm.SEVERAL_TIMES_DAY_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "5", md: "3", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: { type: "number", min: 2, max: 10 },
                                on: { input: _vm.onReminderChange },
                                model: {
                                  value:
                                    _vm.reminderFrequency.severalTimesDay.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.severalTimesDay,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reminderFrequency.severalTimesDay.value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reminderMedicationForm.tabletsDay")
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reminderFrequency.value === _vm.WEEK_DAYS_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h5", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "reminderMedicationForm.selectWeekDays"
                                  )
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-center",
                              attrs: { cols: "12" }
                            },
                            [
                              _c("b-form-checkbox-group", {
                                staticClass: "form-group",
                                attrs: {
                                  options:
                                    _vm.reminderFrequency.weekDays.options,
                                  "value-field": "value",
                                  "text-field": "name"
                                },
                                model: {
                                  value: _vm.reminderFrequency.weekDays.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.weekDays,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "reminderFrequency.weekDays.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reminderFrequency.value === _vm.CYCLIC_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "5", md: "6", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: { type: "number", min: 1 },
                                model: {
                                  value: _vm.reminderFrequency.cyclic.tablets,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.cyclic,
                                      "tablets",
                                      $$v
                                    )
                                  },
                                  expression: "reminderFrequency.cyclic.tablets"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reminderMedicationForm.intakes")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "5", md: "6", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: { type: "number", min: 1 },
                                model: {
                                  value: _vm.reminderFrequency.cyclic.pauses,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.cyclic,
                                      "pauses",
                                      $$v
                                    )
                                  },
                                  expression: "reminderFrequency.cyclic.pauses"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reminderMedicationForm.pauses")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "12" } }, [
                            _c("h5", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("reminderMedicationForm.startDate")
                                )
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", xl: "6" } },
                            [
                              _c("base-datepicker", {
                                attrs: { dateAfterNow: "" },
                                model: {
                                  value: _vm.reminderFrequency.cyclic.startDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.reminderFrequency.cyclic,
                                      "startDate",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "reminderFrequency.cyclic.startDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.reminderFrequency.value === _vm.INTERVAL_FREQUENCY_OPTION
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3", xl: "2" } },
                            [
                              _c("span", {
                                staticClass: "block-center",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("reminderMedicationForm.tablets")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("base-input", {
                                attrs: { type: "number", min: 1 },
                                model: {
                                  value: _vm.medicine.tabletsOptions[0].value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.medicine.tabletsOptions[0],
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "medicine.tabletsOptions[0].value"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "mb-4",
                              attrs: { cols: "12", md: "4", xl: "2" }
                            },
                            [
                              _c("span", {
                                staticClass: "block-center",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("reminderMedicationForm.startHour")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("base-timepicker", {
                                attrs: {
                                  noMarginBottom: "",
                                  buttonOnly: "",
                                  placeholder:
                                    "" +
                                    _vm.$t("reminderMedicationForm.fromHour")
                                },
                                on: {
                                  input: _vm.updateIntervalEndHoursOptions
                                },
                                model: {
                                  value:
                                    _vm.medicine.tabletsOptions[0].startHour,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.medicine.tabletsOptions[0],
                                      "startHour",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "medicine.tabletsOptions[0].startHour"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hoursIntervalSelected
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "mb-4",
                                  attrs: { cols: "12", md: "3", xl: "2" }
                                },
                                [
                                  _c("span", {
                                    staticClass: "block-center",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("reminderMedicationForm.endHour")
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("base-select", {
                                    attrs: {
                                      avoidDefaultSort: "",
                                      noMarginBottom: "",
                                      buttonOnly: "",
                                      options:
                                        _vm.reminderFrequency.interval
                                          .endHoursOptions,
                                      label: "value",
                                      valueProp: "value",
                                      placeholder:
                                        "" +
                                        _vm.$t("reminderMedicationForm.toHour")
                                    },
                                    model: {
                                      value:
                                        _vm.medicine.tabletsOptions[0].endHour,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.medicine.tabletsOptions[0],
                                          "endHour",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "medicine.tabletsOptions[0].endHour"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showTabletsSection
                    ? _c(
                        "div",
                        _vm._l(_vm.medicine.tabletsOptions, function(
                          item,
                          index
                        ) {
                          return _c(
                            "b-row",
                            {
                              key: "tablets" + index,
                              staticClass: "justify-content-center row-gap"
                            },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12", md: "4", xl: "2" } },
                                [
                                  _c("span", {
                                    staticClass: "block-center",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.$t("hour"))
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("base-timepicker", {
                                    attrs: {
                                      noMarginBottom: "",
                                      buttonOnly: "",
                                      placeholder: _vm.$t(
                                        "reminderMedicationForm.hourTitle"
                                      )
                                    },
                                    model: {
                                      value: item.startHour,
                                      callback: function($$v) {
                                        _vm.$set(item, "startHour", $$v)
                                      },
                                      expression: "item.startHour"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "12", md: "3", xl: "2" } },
                                [
                                  _c("span", {
                                    staticClass: "block-center",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("reminderMedicationForm.tablets")
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("base-input", {
                                    attrs: { type: "number", min: 1 },
                                    model: {
                                      value: item.value,
                                      callback: function($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center row-gap mt-5" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("h5", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "reminderMedicationForm.reminderFillQuestion"
                              )
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c("binary-radio-group", {
                            attrs: { noMarginTop: "" },
                            model: {
                              value: _vm.tabletsReminder.enabled,
                              callback: function($$v) {
                                _vm.$set(_vm.tabletsReminder, "enabled", $$v)
                              },
                              expression: "tabletsReminder.enabled"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tabletsReminder.enabled
                    ? _c(
                        "b-row",
                        { staticClass: "justify-content-center row-gap" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: { type: "number", min: 1 },
                                model: {
                                  value: _vm.tabletsReminder.left,
                                  callback: function($$v) {
                                    _vm.$set(_vm.tabletsReminder, "left", $$v)
                                  },
                                  expression: "tabletsReminder.left"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "reminderMedicationForm.reminderMedicineTitle"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "12", md: "3", xl: "2" } },
                            [
                              _c("base-input", {
                                attrs: {
                                  type: "number",
                                  min: 0,
                                  max: _vm.tabletsReminder.left
                                    ? _vm.tabletsReminder.left - 1
                                    : null
                                },
                                model: {
                                  value: _vm.tabletsReminder.limit,
                                  callback: function($$v) {
                                    _vm.$set(_vm.tabletsReminder, "limit", $$v)
                                  },
                                  expression: "tabletsReminder.limit"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "vertical-align",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("reminderMedicationForm.units")
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center row-gap mt-5" },
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c("h5", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "reminderMedicationForm.notificationsQuestion"
                              )
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "base-checkbox",
                            {
                              staticClass: "inline-block",
                              staticStyle: { "margin-right": "3rem" },
                              model: {
                                value: _vm.notifications.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.notifications, "email", $$v)
                                },
                                expression: "notifications.email"
                              }
                            },
                            [_vm._v("Email")]
                          ),
                          _vm._v(" "),
                          _c(
                            "base-checkbox",
                            {
                              staticClass: "inline-block",
                              model: {
                                value: _vm.notifications.whatsapp,
                                callback: function($$v) {
                                  _vm.$set(_vm.notifications, "whatsapp", $$v)
                                },
                                expression: "notifications.whatsapp"
                              }
                            },
                            [_vm._v("Whatsapp")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "justify-content-center mt-5" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12", xl: "6" } },
                        [
                          _c("base-textarea", {
                            attrs: {
                              placeholder:
                                _vm.$t("notes") + " " + _vm.$t("optional")
                            },
                            model: {
                              value: _vm.notes,
                              callback: function($$v) {
                                _vm.notes = $$v
                              },
                              expression: "notes"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-center mt-5" },
                    [
                      _c("base-button", { on: { click: _vm.save } }, [
                        _vm._v(_vm._s(_vm.$t("save")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          attrs: { gray: "" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("onShowReminderMenu")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel-btn")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bde41ae2", esExports)
  }
}

/***/ }),

/***/ 4086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicationReminderBlock_vue__ = __webpack_require__(3519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b72d9d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicationReminderBlock_vue__ = __webpack_require__(4089);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4087)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b72d9d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicationReminderBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b72d9d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicationReminderBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/medicationReminder/MedicationReminderBlock.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4b72d9d2", Component.options)
  } else {
    hotAPI.reload("data-v-4b72d9d2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4087:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4088);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("06d5844c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b72d9d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MedicationReminderBlock.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4b72d9d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MedicationReminderBlock.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4088:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-4b72d9d2]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-4b72d9d2],.slide-down-leave-active[data-v-4b72d9d2]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-4b72d9d2],.slide-down-leave-to[data-v-4b72d9d2]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-4b72d9d2],.slide-fade-left-leave-active[data-v-4b72d9d2]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-4b72d9d2],.slide-fade-left-leave-to[data-v-4b72d9d2]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-4b72d9d2]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-4b72d9d2],.fade-leave-to[data-v-4b72d9d2]{opacity:0\n}\n.medication-card[data-v-4b72d9d2]{min-width:290px;white-space:nowrap\n}\n.medication-card>div[data-v-4b72d9d2]{text-overflow:ellipsis;overflow:hidden\n}\n.medication-color[data-v-4b72d9d2]{color:#3238C4\n}\n.notes[data-v-4b72d9d2]{white-space:initial;font-size:.8rem\n}\n.buttons-section[data-v-4b72d9d2]{white-space:initial;margin-top:1rem\n}\n.buttons-section>button[data-v-4b72d9d2]{margin-top:1rem\n}\n", ""]);

// exports


/***/ }),

/***/ 4089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    { attrs: { cols: "12", xl: "5" } },
    [
      _c("base-card", { staticClass: "medication-card" }, [
        _c("div", {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover:title",
              value: _vm.medicationName,
              expression: "medicationName",
              modifiers: { "hover:title": true }
            }
          ],
          staticClass: "medication-color",
          attrs: { title: _vm.medicationName },
          domProps: { innerHTML: _vm._s(_vm.medicationName) }
        }),
        _vm._v(" "),
        _c("div", {
          attrs: { title: _vm.reminderTypeTitle },
          domProps: { innerHTML: _vm._s(_vm.reminderTypeTitle) }
        }),
        _vm._v(" "),
        _vm.tabletsLeft !== null
          ? _c("div", { staticClass: "mt-2" }, [
              _vm._v(_vm._s(_vm.$t("tabletsLeft") + ": " + _vm.tabletsLeft))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "mt-2 notes",
          domProps: { innerHTML: _vm._s(_vm.notes) }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons-section" },
          [
            _c(
              "base-button",
              {
                attrs: { blue: "" },
                on: {
                  click: function($event) {
                    return _vm.$emit("onEdit", _vm.id)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("edit")))]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: { red: "" },
                on: {
                  click: function($event) {
                    _vm.showDeleteDialog = true
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("remove")))]
            ),
            _vm._v(" "),
            _vm.tabletsReminderSent
              ? _c(
                  "base-button",
                  { attrs: { white: "" }, on: { click: _vm.resetTablets } },
                  [_vm._v(_vm._s(_vm.$t("resetTabletsReminder")))]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          okBtnText: _vm.$t("yes"),
          cancelBtnText: _vm.$t("no"),
          okFn: function() {
            _vm.deleteMedication()
          },
          cancelFn: function() {
            _vm.showDeleteDialog = false
          },
          content: _vm.$t("confirmRemoveMedicationReminder")
        },
        model: {
          value: _vm.showDeleteDialog,
          callback: function($$v) {
            _vm.showDeleteDialog = $$v
          },
          expression: "showDeleteDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b72d9d2", esExports)
  }
}

/***/ }),

/***/ 4090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.showCreateForm
        ? _c("div", { staticClass: "mb-5" }, [
            _c(
              "span",
              { on: { click: _vm.onAddReminder } },
              [
                _c("add-button", {
                  attrs: {
                    buttonText: _vm.$t("addNewMedicationReminder"),
                    showTextOnMobile: ""
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreateForm
        ? _c("medication-reminder-form", {
            attrs: {
              formData: _vm.formData,
              medicationCode: _vm.medicationCode
            },
            on: { onShowReminderMenu: _vm.onShowReminderMenu }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showCreateForm
        ? _c(
            "b-row",
            { staticClass: "row-gap" },
            _vm._l(_vm.reminders, function(item, index) {
              return _c("medication-reminder-block", {
                key: "reminderBlock" + index,
                attrs: {
                  id: item.id,
                  reminderType: item.reminderType,
                  medicationName: item.medication.name,
                  tabletsLeft: item.tabletsReminder.left,
                  notes: item.notes,
                  interval: item.interval,
                  cyclic: item.cyclic,
                  severalTimesWeek: item.severalTimesWeek,
                  severalTimesDay: item.severalTimesDay,
                  tabletsReminderSent: item.tabletsReminder.reminderSent
                },
                on: {
                  onEdit: function($event) {
                    return _vm.loadFormData($event)
                  },
                  onDelete: _vm.onShowReminderMenu,
                  onRefreshMedications: _vm.onShowReminderMenu
                }
              })
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67cd7020", esExports)
  }
}

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicationReminderView_vue__ = __webpack_require__(3516);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67cd7020_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicationReminderView_vue__ = __webpack_require__(4090);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4080)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67cd7020"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MedicationReminderView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67cd7020_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MedicationReminderView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/medicationReminder/MedicationReminderView.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-67cd7020", Component.options)
  } else {
    hotAPI.reload("data-v-67cd7020", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/7.44e325c06488243e9ca7.js